"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configureFramework = void 0;
/* eslint-disable no-console */
const session_1 = require("../../session");
const authenticator_1 = require("../../authenticator");
const features_1 = require("../../features");
const store_1 = require("../../store");
const storage_1 = require("../../session/cc/storage");
const managerFunctions_1 = require("./managerFunctions");
const deleteCookies_1 = require("../../utils/deleteCookies/deleteCookies");
const configureFramework = (bankId, language, additionalPlugins = [], { sessionStore, } = {
    sessionStore: (0, store_1.getDefaultCookiesStore)(),
}) => {
    const Session = new session_1.MbUSDSession(new storage_1.MbCCSessionStorage(sessionStore));
    //TODO Session needs XHR Authplugin and this plugin needs session
    const plugins = [...additionalPlugins, new features_1.XHRAcceptLanguagePlugin(language), new features_1.XHRBankIdPlugin(bankId)];
    Session.setXHR(new features_1.XHR({
        plugins,
    }));
    // TODO: Spot fix to call logout inside notifyInteractionEnded.
    let Authenticator = null;
    const UsdManager = new features_1.ModelbankUSDManager((0, managerFunctions_1.getManagerFunctions)(Session, Authenticator, {
        notifyInteractionEnded: () => {
            (0, deleteCookies_1.deleteCookies)(['.stg.cc.openbank.mx', '.stg.openbank.mx', '.openbank.mx']);
        },
    }));
    const AuthApi = new features_1.XHR({ plugins });
    Authenticator = new authenticator_1.MbUSDAuthenticator(Session, AuthApi, UsdManager);
    return {
        Authenticator,
        UsdManager,
        Session,
    };
};
exports.configureFramework = configureFramework;
//# sourceMappingURL=base.js.map